export default __webpack_public_path__ + "static/media/Create-documentation.bb234184.md";